<div *ngIf="category.visible">

    <app-category-coupon-slider-1
    [coupon]="coupon"
    [category]="category"
    [typeCode]="typeCode"
    (couponSettingsChanged)="changeCouponSettings()"
    >
    </app-category-coupon-slider-1>
    
    <app-category-coupon-slider-2
    [coupon]="coupon"
    [category]="category"
    [typeCode]="typeCode"
    (couponSettingsChanged)="changeCouponSettings()"
    >
    </app-category-coupon-slider-2>
    
    <app-category-coupon-slider-3
    [coupon]="coupon"
    [category]="category"
    [typeCode]="typeCode"
    (couponSettingsChanged)="changeCouponSettings()"
    >
    </app-category-coupon-slider-3>

</div>




// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/category-coupons-slider/category-coupons-slider.component.html